import React from 'react'
import { useFinancingRequestStepper } from './hooks/useFinancingRequestStepper'
import type { TFinancingRequestStepperProps } from './types'
import { EFinancingConsultingStep } from './types'

export const FinancingRequestStepper = <TForm extends Record<string, unknown>>({
  FormComponent,
  LoginComponent,
  RegistrationComponent,
  ErrorComponent,
  SuccessComponent,
  AfterFormSubmitComponent,
  initialFormValues,
}: TFinancingRequestStepperProps<TForm>) => {
  const { state, handlers } = useFinancingRequestStepper<TForm>()

  switch (state.step) {
    case EFinancingConsultingStep.FORM:
      return <FormComponent initialFormValues={initialFormValues} state={state} {...handlers} />
    case EFinancingConsultingStep.LOGIN:
      return <LoginComponent state={state} {...handlers} />
    case EFinancingConsultingStep.REGISTRATION:
      return <RegistrationComponent state={state} {...handlers} />
    case EFinancingConsultingStep.AFTER_FORM_SUBMIT: {
      if (!AfterFormSubmitComponent) {
        throw new Error('AfterFormSubmitComponent is required for EFinancingConsultingStep.AFTER_FORM_SUBMIT step')
      }

      return <AfterFormSubmitComponent state={state} {...handlers} />
    }
    case EFinancingConsultingStep.SUCCESS:
      return <SuccessComponent state={state} {...handlers} />
    case EFinancingConsultingStep.ERROR:
      return <ErrorComponent state={state} {...handlers} />
    default:
      throw new Error('Incorrect state of FinancingRequestStepper')
  }
}
